import { emailRegex } from 'noddi-util';
import { z } from 'zod';

type Translations = {
  thisFieldIsRequired: string;
  thisFieldMustBeAtLeast2CharactersLong: string;
  mustProvideAValidEmailAddress: string;
  passwordsMustMatch: string;
  thePasswordMustBeAtLeast8CharactersLong: string;
};

export const userRegistrationFormSchema = (skipPasswordCreation: boolean, translations: Translations) => {
  const base = z.object({
    firstName: z
      .string()
      .min(1, translations.thisFieldIsRequired)
      .min(2, translations.thisFieldMustBeAtLeast2CharactersLong),
    surname: z
      .string()
      .min(1, translations.thisFieldIsRequired)
      .min(2, translations.thisFieldMustBeAtLeast2CharactersLong),
    email: z
      .string()
      .min(1, translations.thisFieldIsRequired)
      .regex(emailRegex, translations.mustProvideAValidEmailAddress)
      .pipe(z.email(translations.mustProvideAValidEmailAddress)),
    password: skipPasswordCreation
      ? z.string()
      : z
          .string()
          .min(1, translations.thisFieldIsRequired)
          .min(8, translations.thePasswordMustBeAtLeast8CharactersLong),
    confirmPassword: skipPasswordCreation ? z.string() : z.string().min(1, translations.thisFieldIsRequired)
  });

  if (skipPasswordCreation) {
    return base;
  }

  return base.refine((data) => data.password === data.confirmPassword, {
    message: translations.passwordsMustMatch,
    path: ['confirmPassword']
  });
};

export type UserRegistrationFormValues = z.input<ReturnType<typeof userRegistrationFormSchema>>;
